import React from 'react';
import { CSVDownload } from "react-csv";

const ExportCsvFile = ({ csvReport }: any) => {
    return (
        <CSVDownload {...csvReport} target="_blank" />

    )
}
export default ExportCsvFile;